import {
  fetchMembers,
  setReorderTopicField,
} from "../../../redux/slices/reorderTopicSlice";
import {
  React,
  useEffect,
  useDispatch,
  useSelector,
  useModal,
  useNavigate,
} from "../../../globals/imports";
import { getAppPrefix } from "../../EmbedChannels/utility/embedHelper";

const MembersTab = ({ channelId, isOwner }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleOpenModal } = useModal();
  const reorderMembers = useSelector((state) => state.reorderTopic.members);
  const myData = useSelector((state) => state.myData);
  const memberStatus = useSelector((state) => state.reorderTopic.memberStatus);

  useEffect(() => {
    dispatch(fetchMembers(channelId));
  }, [channelId, dispatch]);

  const handleRemoveMember = (user, channelId) => {
    dispatch(
      setReorderTopicField({ field: "removeChannelId", value: channelId })
    );
    dispatch(setReorderTopicField({ field: "removeUser", value: user }));
    handleOpenModal("modalRemoveMemberOpen");
  };

  if (memberStatus === "loading") {
    return (
      <div className="text-theme-secondaryText text-center mt-12 justify-center items-center">
        Loading...
      </div>
    );
  }

  if (reorderMembers.length === 0) {
    return (
      <div className="text-theme-secondaryText text-center mt-12 justify-center items-center">
        No members found.
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {reorderMembers.map((member, index) => {
        // fetch_channel_members returns membership docs with a populated `user`;
        // fall back to the membership itself for any older flat shape.
        const u = member.user || member;
        if (u.username && u.username === myData.username) return null;
        return (
            <div key={u._id || member._id || index} className="flex flex-col">
              <div className="rounded-lg px-2 py-3 flex flex-row justify-between items-center ">
                <div
                  className="flex flex-row items-center justify-start w-max cursor-pointer"
                  onClick={() => {
                    // Open a DM with this member (we no longer use per-user
                    // subdomains like username.channels.social).
                    if (u.username && myData?.username)
                      navigate(
                        `${getAppPrefix()}/user/${myData.username}/messages/list/${u.username}`
                      );
                  }}
                >
                  {u.logo ? (
                    <img
                      src={u.logo}
                      alt="logo"
                      className="rounded-full w-10 h-10 object-cover"
                    />
                  ) : (
                    <div
                      className="rounded-full w-10 h-10 flex items-center justify-center text-sm font-bold text-gray-900"
                      style={{ backgroundColor: u.color_logo || "#C4C4C4" }}
                    >
                      {(u.name || u.username || "?").charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div className="flex flex-col ml-2 justify-center">
                    <p className="text-theme-secondaryText font-normal text-sm">
                      {u.name || u.username || "Member"}
                    </p>
                    {u.name && u.username && (
                      <p className="text-theme-description text-[11px] font-normal">
                        @{u.username}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-row ">
                  {isOwner && (
                    <div
                      className="bg-theme-tertiaryBackground rounded-md p-2 text-theme-primaryText text-sm font-light cursor-pointer"
                      onClick={() => handleRemoveMember(member, channelId)}
                    >
                      Remove
                    </div>
                  )}
                </div>
              </div>
              <div className="border-t border-t-theme-chatDivider w-full px-4"></div>
            </div>
        );
      })}
    </div>
  );
};

export default MembersTab;
